import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  }
};

// Force French language regardless of localStorage
localStorage.setItem('language', 'fr');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Always use French
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
});

// Override changeLanguage to prevent switching to English within the app
// (redirection is handled in Nav.js)
const originalChangeLanguage = i18n.changeLanguage;
i18n.changeLanguage = function(lng) {
  // If trying to change to English, let Nav.js handle the redirection
  if (lng === 'en') {
    return originalChangeLanguage.call(this, 'fr');
  }
  return originalChangeLanguage.call(this, lng);
};

// Force i18n.language to always return 'fr' for API calls
Object.defineProperty(i18n, 'language', {
  get: function() { return 'fr'; }
});

export default i18n;
